// CORE
// NODE_MODULE
import _ from 'lodash';

// TEMPLATE
import T_template from '../../../tpl/blocks/template_inventory.ejs';

// LIBS
// PRINTER
// UTILS
import Utils from '@libs/utils/Utils';

// MODAL
// CUSTOM_ELEMENT
// SERVICE
import S_Product from '@services/Product/ProductService';

class Stock {
	public async print(data: { [key: string]: any }[], groupKey: string, title: string) {
		const group: { [brand: string]: any } = _.groupBy(data, groupKey);

		let result: { [key: string]: any }[] = [];

		const productKey = S_Product.getInstance().referenceKey;

		for (const key in group) {
			group[key] = _.sortBy(group[key], 'product.' + productKey);

			for (const item of group[key]) {
				const groupKeyData = _.get(item, groupKey) || 'NON RENSEIGNEE';

				result.push({
					type: 'product',
					reference: item.product[productKey].length < 15 ? item.product[productKey] : item.product[productKey].slice(0, 15 - 3) + '...',
					name: item.product.name.length < 70 ? item.product.name : item.product.name.slice(0, 70 - 3) + '...',
					groupKey: groupKeyData.toUpperCase(),
					locationStock: item.product.locationStock,
					brand: item.product.brand,
					oldQuantity: item.oldQuantity,
					newQuantity: item.newQuantity
				});
			}
		}

		result = _.sortBy(result, ['groupKey', productKey]) as any[];

		let tmpGroupKey = '';
		for (let i = 0; i < result.length; i++) {
			if (tmpGroupKey !== result[i].groupKey) {
				result.splice(i, 0, {
					type: 'groupKey',
					label: result[i].groupKey
				});

				i++;

				tmpGroupKey = result[i].groupKey;
			}

			if (i % 54 === 0) {
				result.splice(i, 0, {
					type: 'groupKey',
					label: tmpGroupKey
				});

				i++;
			}
		}

		const N_container = document.createElement('div');

		N_container.classList.add('containerPrint');

		const chunkMaterials = _.chunk(result, 54);

		let page = 1;
		for (const chunk of chunkMaterials) {
			N_container.innerHTML += T_template({
				title,
				page: (page++),
				totalPage: chunkMaterials.length,
				data: chunk,
				groupKey
			});
		}

		document.body.appendChild(N_container);

		setTimeout(() => {
			window.print();

			document.body.removeChild(N_container);

			Utils.removeTooltip();
		}, 1000);
	}
}

export default Stock;
